import { useReducer } from 'react'
import {
    INITIATE_FETCHING,
    FETCH_SUCCESS,
    FETCH_ERROR
} from "../../common/constants/constants";

const initialFetchingState = {
    loader: false,
    error: false,
    errorMsg: null,
    errorCode: null,
    alertData: {
        'alertTitle': '',
        'alertmsg': '',
        'showAlert': false
    }
};

const fetchingDataReducer = (state, action) => {

    switch (action.type) {
        case INITIATE_FETCHING:
            return { ...state, loader: true, error: false };
        case FETCH_SUCCESS:
            return initialFetchingState;
        case FETCH_ERROR:
            return {
                ...initialFetchingState,
                alertData: action.alertData,
                error: true
            };
        default:
            return initialFetchingState
    }
};

function useApiHook() {
    const [fetchState, setFetchingState] = useReducer(fetchingDataReducer, initialFetchingState);

    const setAPIFetechingState = prop => {
        setFetchingState(prop)
    }

    return [fetchState, setAPIFetechingState]
}

export default useApiHook